var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"pl-7"},[_c('div',{staticClass:"primary1--text headline font-weight-bold"},[_vm._v("\n          GERENCIAMENTO DE TOKEN\n        ")])])],1),_c('TabelaGerenciamentoToken')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }